import { timeLeftForBid } from '../utils/date-util';
import eventConstants from './eventConstants';
import TagManager from 'react-gtm-module';

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID
};

export const initGA = () => {
    TagManager.initialize(tagManagerArgs);
};

export const sendEvent = (data) => {
    if (window.dataLayer) {
        window.dataLayer.push({ ...data });
    }
};

export const trackCustomEvents = ({ platformEvents, category }, extras) => {
    const data = { ...extras, ...platformEvents[category] };
    sendEvent(data);
};

export const trackDealerEvents = (category, extras = {}) => {
    trackCustomEvents({
        platformEvents: eventConstants,
        category
    }, {
        ...extras
    });
};

export const prepareGADataAndSendEvent = (event, user, auction, pageType, extras = {}) => {
    const { auctionId, lastHighestBid, auctionEndTimestamp, auctionType, appointmentId, make, model, variant, year } = auction || {};
    const { mobilePhone, dealerCode, contactPerson, dealerType } = user || {};
    const { primaryMobileNumber } = contactPerson || {};
    const timeLeft = auctionEndTimestamp && timeLeftForBid(auctionEndTimestamp);
    trackDealerEvents(event, { ...extras, phone: (mobilePhone || primaryMobileNumber), dealerType, dealerCode, pageType, ecommerce: auction && { items: [{ auctionId, appointmentId, timeLeft, auctionType, lastHighestBid, make, model, variant, year }] } });
};